var _style, _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 217,
    r: 32.5,
    fill: "#F9AF17"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 512,
    r: 32.5,
    fill: "#F9AF17"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 807,
    r: 32.5,
    fill: "#F9AF17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35a4dd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M165.1 512H983M165.1 807H983M165.1 217H983"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default ForwardRef;